<template>
  <transition
    :name="transitionName"
    mode="out-in"
    @after-leave="afterLeave">
    <div
      class="child-info-form"
      :key="'child-id-form' + childId">
      <div class="row">
        <div class="col-xs-12">
          <form class="form">
            <div class="row">
              <div class="col-xs-12">
                <h3 class="form__section-heading">Entering Grade</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-3">
                <div class="form__group">
                  <input
                    @change="updateChildEnteringGrade({childId, $event})"
                    :checked="currentChild.enteringGrade === '9'"
                    class="form__radio"
                    id="enteringGradeNine"
                    type="radio"
                    name="enteringGrade"
                    value="9">
                  <label
                    class="form__label--radio"
                    for="enteringGradeNine"><span class="label__title">9</span></label>
                </div>
              </div>
              <div class="col-xs-3">
                <div class="form__group">
                  <input
                    @change="updateChildEnteringGrade({childId, $event})"
                    :checked="currentChild.enteringGrade === '10'"
                    class="form__radio"
                    id="enteringGradeTen"
                    type="radio"
                    name="enteringGrade"
                    value="10">
                  <label
                    class="form__label--radio"
                    for="enteringGradeTen"><span class="label__title">10</span></label>
                </div>
              </div>
              <div class="col-xs-3">
                <div class="form__group">
                  <input
                    @change="updateChildEnteringGrade({childId, $event})"
                    :checked="currentChild.enteringGrade === '11'"
                    class="form__radio"
                    id="enteringGradeEleven"
                    type="radio"
                    name="enteringGrade"
                    value="11">
                  <label
                    class="form__label--radio"
                    for="enteringGradeEleven"><span class="label__title">11</span></label>
                </div>
              </div>
              <div class="col-xs-3">
                <div class="form__group">
                  <input
                    @change="updateChildEnteringGrade({childId, $event})"
                    :checked="currentChild.enteringGrade === '12'"
                    class="form__radio"
                    id="enteringGradeTwelve"
                    type="radio"
                    name="enteringGrade"
                    value="12">
                  <label
                    class="form__label--radio"
                    for="enteringGradeTwelve"><span class="label__title">12</span></label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3 class="form__section-heading">School</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-6">
                <div class="form__group">
                  <input
                    @change="updateChildEnteringSchool({childId, $event})"
                    :checked="currentChild.enteringSchool === 'Boys'"
                    class="form__radio"
                    id="schoolBoys"
                    type="radio"
                    name="school"
                    value="Boys">
                  <label
                    class="form__label--radio"
                    for="schoolBoys"><span class="label__title">Boys</span></label>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="form__group">
                  <input
                    @change="updateChildEnteringSchool({childId, $event})"
                    :checked="currentChild.enteringSchool === 'Girls'"
                    class="form__radio"
                    id="schoolGirls"
                    type="radio"
                    name="school"
                    value="Girls">
                  <label
                    class="form__label--radio"
                    for="schoolGirls"><span class="label__title">Girls</span></label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ChildInfoForm',
  data() {
    return {
      transitionName: this.$parent.$parent.transitionName,
      childId: this.$route.params.childId,
    };
  },
  mounted() {
    this.getChild(this.childId);
  },
  computed: {
    ...mapGetters([
      'currentChild',
    ]),
  },
  methods: {
    ...mapActions([
      'getChild',
      'updateChildEnteringGrade',
      'updateChildEnteringSchool',
    ]),
    afterLeave() {
      const main = document.getElementsByTagName('main')[0];
      main.scrollTop = 0;
    },
  },
  watch: {
    '$route.params.childId': function (to) {
      this.childId = to;
      this.getChild(to);
    },
  },
};
</script>

<style lang="scss">
</style>

